import { PAYERS_API_URL, PAYERS_FILTER_URL, PAYERS_SEARCH_ALTERABLE_URL, PAYERS_SEARCH_AVAILABLE_URL } from 'constants/ApiConstants';
import { cleanPayload } from 'utils/RequestUtils';

import * as types from './actionTypes';

export const filterPayers = (params, meta = {}) => ({
  type: types.FILTER_PAYERS,
  payload: {
    request: {
      method: 'GET',
      url: PAYERS_FILTER_URL,
      params: {
        page: 0,
        sort: 'createdOn,asc',
        ...params,
      },
    },
  },
  meta: { '@app-request': true, ...meta },
});

/**
 * @param {Object} params
 * @param {Object} [meta={}]
 * @returns {import('./types').FetchPayersAction}
 */
export const fetchPayers = (params, meta = {}) => ({
  type: types.FETCH_PAYERS,
  payload: {
    request: {
      method: 'GET',
      url: PAYERS_SEARCH_ALTERABLE_URL,
      params,
    },
  },
  meta: { '@app-request': true, ...meta },
});

export const fetchAvailablePayers = (params, meta = {}) => ({
  type: types.FETCH_AVAILABLE_PAYERS,
  payload: {
    request: {
      method: 'GET',
      url: PAYERS_SEARCH_AVAILABLE_URL,
      params,
    },
  },
  meta: { '@app-request': true, ...meta },
});

/**
 * @param {string} payerId
 * @param {Object} [meta={}]
 * @returns {import('./types').FetchPayerAction}
 */
export const fetchPayer = (payerId, meta = {}) => ({
  type: types.FETCH_PAYER,
  payload: {
    request: {
      method: 'GET',
      url: `${PAYERS_API_URL}/${payerId}`,
    },
  },
  meta: { ...meta, '@app-request': true },
});

/**
 * @param {import('./types').Payer} payer
 * @param {Object} [meta={}]
 * @returns {import('./types').PostPayerAction}
 */
export const createPayer = (payer, meta = {}) => ({
  type: types.POST_PAYER,
  payload: {
    request: {
      method: 'POST',
      url: PAYERS_API_URL,
      data: cleanPayload(payer),
    },
  },
  meta,
});

/**
 * @param {import('./types').Payer} payer
 * @param {Object} [meta={}]
 * @returns {import('./types').PutPayerAction}
 */
export const updatePayer = (payer, meta = {}) => ({
  type: types.PUT_PAYER,
  payload: {
    request: {
      method: 'PUT',
      url: `${PAYERS_API_URL}/${payer.id}`,
      data: cleanPayload(payer),
    },
  },
  meta,
});

/**
 * @param {string} payerId
 * @param {Object} [meta={}]
 * @returns {import('./types').DeletePayerAction}
 */
export const deletePayer = (payerId, meta = {}) => ({
  type: types.DELETE_PAYER,
  payload: {
    request: {
      method: 'DELETE',
      url: `${PAYERS_API_URL}/${payerId}`,
    },
    payerId,
  },
  meta,
});

/**
 * @param {string} id
 * @param {Object} [meta={}]
 * @returns {import('./types').DeletePayerSuccessAction}
 */
export const deletePayerSuccess = (id, meta = {}) => ({
  type: types.DELETE_PAYER_SUCCESS,
  payload: id,
  meta,
});

/**
 * @param {string} error
 * @param {Object} [meta={}]
 * @returns {import('./types').DeletePayerFailureAction}
 */
export const deletePayerFailure = (error, meta = {}) => ({
  type: types.DELETE_PAYER_FAILURE,
  payload: error,
  error: true,
  meta,
});

/**
 *
 * @param {string} field
 * @param {unknown} value
 * @param {Object} [meta={}]
 * @returns {import("./types").SetPayerDashboardFilterAction}
 */
export const setPayerDashboardFilter = (field, value, meta = {}) => ({
  type: types.SET_PAYERS_DASHBOARD_FILTER,
  payload: { field, value },
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("./types").SetIsReadyAction}
 */
export const setIsReady = (meta = {}) => ({
  type: types.SET_IS_READY,
  meta,
});
